module.exports = __webpack_public_path__ + "img/kariba.2c76ce62.png";